import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageRevisionFragmentFragmentDoc } from '../fragments/servicePackageRevision.generated';
import { ServicePackageFragmentFragmentDoc } from '../fragments/servicePackage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CopyServicePackageToTermMutationVariables = Types.Exact<{
  input: Types.CopyServicePackageToTermInput;
}>;


export type CopyServicePackageToTermMutation = { __typename?: 'Mutation', copyServicePackageToTerm: { __typename?: 'SaveServicePackageRevisionResult', revision: { __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }, package: { __typename?: 'ServicePackage', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revisions: Array<{ __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }> } } };


export const CopyServicePackageToTermDocument = gql`
    mutation copyServicePackageToTerm($input: CopyServicePackageToTermInput!) {
  copyServicePackageToTerm(input: $input) {
    revision {
      ...ServicePackageRevisionFragment
    }
    package {
      ...ServicePackageFragment
    }
  }
}
    ${ServicePackageRevisionFragmentFragmentDoc}
${ServicePackageFragmentFragmentDoc}`;
export type CopyServicePackageToTermMutationFn = Apollo.MutationFunction<CopyServicePackageToTermMutation, CopyServicePackageToTermMutationVariables>;

/**
 * __useCopyServicePackageToTermMutation__
 *
 * To run a mutation, you first call `useCopyServicePackageToTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyServicePackageToTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyServicePackageToTermMutation, { data, loading, error }] = useCopyServicePackageToTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyServicePackageToTermMutation(baseOptions?: Apollo.MutationHookOptions<CopyServicePackageToTermMutation, CopyServicePackageToTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyServicePackageToTermMutation, CopyServicePackageToTermMutationVariables>(CopyServicePackageToTermDocument, options);
      }
export type CopyServicePackageToTermMutationHookResult = ReturnType<typeof useCopyServicePackageToTermMutation>;
export type CopyServicePackageToTermMutationResult = Apollo.MutationResult<CopyServicePackageToTermMutation>;
export type CopyServicePackageToTermMutationOptions = Apollo.BaseMutationOptions<CopyServicePackageToTermMutation, CopyServicePackageToTermMutationVariables>;